import { HTMLAttributes, ReactNode, useMemo } from 'react';

import styles from './PanelList.module.css';

type PanelListProps<T> = HTMLAttributes<HTMLUListElement> & {
  data: T[];
  row: (item: T, index?: number) => ReactNode;
  filter?: (item: T, index?: number) => boolean;
};
const PanelList = <T,>({ data, row, filter = undefined }: PanelListProps<T>) => {
  const filteredData = useMemo(() => (filter ? data.filter(filter) : data), [data, filter]);
  return <ul className={styles.panelList}>{filteredData.map(row)}</ul>;
};
export default PanelList;
